import { useAuth } from "@/contexts/AuthContext";
import { ADMIN } from "@/constants/testIds";
import { LayoutDashboard, FileText, UtensilsCrossed, Image, Settings, LogOut, ExternalLink } from "lucide-react";

export default function AdminLayout({ children, activeTab, setActiveTab }) {
  const { user, logout } = useAuth();

  const navItems = [
    { id: "overview", label: "Dashboard", icon: LayoutDashboard },
    { id: "content", label: "Conteúdo", icon: FileText },
    { id: "menu", label: "Ementa", icon: UtensilsCrossed },
    { id: "gallery", label: "Galeria", icon: Image },
    { id: "settings", label: "Configurações", icon: Settings },
  ];

  return (
    <div className="min-h-screen flex bg-[#F9FAFB] font-lato">
      {/* Sidebar */}
      <aside className="w-64 bg-[#111827] text-white flex flex-col fixed inset-y-0 left-0 z-40">
        {/* Brand */}
        <div className="px-6 py-6 border-b border-gray-700/50">
          <span className="font-dancing text-[#0077B6] text-xl block">O Quinto Império</span>
          <p className="font-lato text-xs text-gray-500 tracking-widest uppercase mt-0.5">Admin</p>
        </div>

        {/* Navigation */}
        <nav className="flex-1 px-3 py-4 overflow-y-auto">
          {navItems.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              onClick={() => setActiveTab(id)}
              data-testid={`admin-tab-${id}`}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded text-sm font-lato transition-all duration-200 mb-1 text-left ${
                activeTab === id
                  ? "bg-[#0077B6] text-white"
                  : "text-gray-400 hover:bg-gray-700/50 hover:text-white"
              }`}
            >
              <Icon size={16} />
              {label}
            </button>
          ))}
        </nav>

        {/* User info + logout */}
        <div className="px-4 py-4 border-t border-gray-700/50">
          <div className="px-2 mb-3">
            <p className="text-xs text-gray-400 truncate">{user?.email}</p>
          </div>
          <div className="flex gap-2">
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 flex items-center justify-center gap-1 text-xs text-gray-400 hover:text-white transition-colors py-2 px-2 rounded hover:bg-gray-700/50"
            >
              <ExternalLink size={13} />
              Website
            </a>
            <button
              onClick={logout}
              data-testid={ADMIN.logoutBtn}
              className="flex-1 flex items-center justify-center gap-1 text-xs text-gray-400 hover:text-red-400 transition-colors py-2 px-2 rounded hover:bg-gray-700/50"
            >
              <LogOut size={13} />
              Sair
            </button>
          </div>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 ml-64 min-h-screen overflow-y-auto">
        {children}
      </main>
    </div>
  );
}
